var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"vuecontainer",attrs:{"id":"vuecontainer"}},[(_vm.loadingshow)?_c('div',{staticClass:"loading"},[_c('i',{staticClass:"el-icon-loading"}),_c('div',{staticClass:"text"},[_vm._v("努力加载中")])]):_vm._e(),_vm._v(" "),_c('router-view',{key:_vm.$route.fullPath,on:{"loading":_vm.loading,"page":_vm.page,"_function":_vm._function}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }